
import axios from 'axios';
import store from '../store/store'

const url=store.rootUrl
// 创建axios 实例
const xhr = axios.create({
  baseURL: url,
   
});
axios.defaults.timeout = 3000;

// request 拦截器
xhr.interceptors.request.use(
  config => {
     
    let openid='';
    let userStr=sessionStorage.getItem('user');
    let useropenid=sessionStorage.getItem('openid')
    if(store.openid&&store.openid.length>0){
      openid=store.openid
    }else if(useropenid&&useropenid.length>0){
      openid=useropenid
    }else if(userStr&&userStr.length>0){
      let data=JSON.parse(userStr)  
      openid = data.openid;
    }
    
   if(openid.length>0) {
    config.headers.openId = openid;
   } 
   
    
  return config;
  },
  err => {
      return Promise.reject(err);
  }
);
// response 拦截器
xhr.interceptors.response.use(
  response => {
    // token过期
    if (response.data.code === 1101) {
       alert('请先去个人中心认证技师')
    } else if (response.data.code !== 0) {
       alert(response.data.code+':'+response.data.message)
    }
    return response;
  },
  error => {
    return Promise.reject(error.response.data.message)  // 返回接口返回的错误信息
  }
);

export default xhr;



// WEBPACK FOOTER //
// ./src/api/setting.js